
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='ui stackable grid receipe'>
  <div className='ui sixteen wide column c'>
    Ofengemüse mit gratiniertem Ziegenkäse und Zimt-Tomatendip
  </div>
  <div className='ui six wide column a'>400 g Zucchini</div>
  <div className='ui ten wide column b' />
  <div className='ui six wide column a'>400 g Auberginen</div>
  <div className='ui ten wide column b'>und</div>
  <div className='ui six wide column a'>300 g Paprika</div>
  <div className='ui ten wide column b'>
    waschen, putzen und in ca. 1 cm grosse Stücke schneiden. Mit
  </div>
  <div className='ui six wide column a'>4 EL Olivenöl</div>
  <div className='ui ten wide column b'>und</div>
  <div className='ui six wide column a'>4 Zweigen Rosmarin</div>
  <div className='ui ten wide column b'>
    auf ein Backblech geben und bei 200 °C Ober- und Unterhitze ca. 40 Min.
    backen, bis das Gemüse weich ist. Dann
  </div>
  <div className='ui six wide column a'>4 Scheiben Ziegenkäse</div>
  <div className='ui ten wide column b'>
    auf das Gemüse legen und übergrillen.
  </div>
  <div className='ui sixteen wide column c'>Für den Zimt-Tomatendip</div>
  <div className='ui six wide column a'>1 Zwiebel</div>
  <div className='ui ten wide column b'>fein würfeln.</div>
  <div className='ui six wide column a'>250 g Tomaten</div>
  <div className='ui ten wide column b'>
    waschen und klein schneiden. Zwiebel in
  </div>
  <div className='ui six wide column a'>1 EL Olivenöl</div>
  <div className='ui ten wide column b'>andünsten.</div>
  <div className='ui six wide column a'>50 g Rote Linsen,</div>
  <div className='ui ten wide column b'>die Tomaten und</div>
  <div className='ui six wide column a'>100 ml Gemüsefond</div>
  <div className='ui ten wide column b'>
    dazugeben und in ca. 15 Min. weich kochen. Von
  </div>
  <div className='ui six wide column a'>5 Stielen Minze</div>
  <div className='ui ten wide column b'>
    die Blättchen abzupfen und fein hacken. Zusammen mit
  </div>
  <div className='ui six wide column a'>1 Messerspitze Zimtpulver</div>
  <div className='ui ten wide column b'>zu den Tomaten geben und mit</div>
  <div className='ui six wide column a'>Salz</div>
  <div className='ui ten wide column b'>und</div>
  <div className='ui six wide column a'>Chilipulver</div>
  <div className='ui ten wide column b'>abschmecken.</div>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;